(function () {
  'use strict';

  /* @ngdoc object
   * @name missingSignIn
   * @description
   *
   */
  angular
    .module('missingSignIn', [
      'ui.router'
    ]);
}());
